import React, { useState, useEffect } from "react";
import CancerBlog from '../assets/Blogs/CervicalcancerBlogs.jpg';
import DietBlog from '../assets/Blogs/DashDietBlogs.jpg';
import DiabetesBlog from '../assets/Blogs/DiabatesDayBlogs.jpg';
import LungCancerBlog from '../assets/Blogs/LungCancerBlogs.jpg';
import PancreaticCancerBlog from '../assets/Blogs/PANCREATICCancerBlogs.jpg';
import PreeclampsiaBlog from '../assets/Blogs/PreeclampsiaBlogs.jpg';
import WCOPDBlog from '../assets/Blogs/WorldCOPDBlogs.jpg';

const Talks_Blogs = () => {
  const [activeVideo, setActiveVideo] = useState(0);
  const [activeBlog, setActiveBlog] = useState(0);

  const videos = [
    "q2cE1y3ic3o",
    "Xy9L0RJp7u0",
    "OF9Em5QmEqw",
    "uwJEXAMgIN0",
  ];

  const blogs = [
    { src: CancerBlog, href: "https://example.com/blog1" },
    { src: DietBlog, href: "https://example.com/blog2" },
    { src: DiabetesBlog, href: "https://example.com/blog3" },
    { src: LungCancerBlog, href: "https://example.com/blog4" },
    { src: PancreaticCancerBlog, href: "https://example.com/blog5" },
    { src: PreeclampsiaBlog, href: "https://example.com/blog6" },
    { src: WCOPDBlog, href: "https://example.com/blog7" },
  ];

  // Auto-switch functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveBlog((prevIndex) => (prevIndex + 1) % blogs.length);
    }, 2000); // Switch every 5 seconds

    // Clear interval when the component unmounts or user clicks on navigation
    return () => clearInterval(interval);
  }, [blogs.length]);

  return (
    <div className="flex flex-row gap-4 p-4 bg-gray-100 min-h-100">
      {/* Left Panel (Videos) */}
      <div className="w-1/2 bg-white shadow-lg rounded-lg p-4 flex flex-col justify-between transition-all duration-500">
        <h2 className="text-xl font-bold mb-4">Health Talks</h2>
        <div className="mb-4 flex-grow">
          <iframe
            className="w-full h-full rounded-lg transition-all duration-500"
            src={`https://www.youtube.com/embed/${videos[activeVideo]}`}
            title="YouTube video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <div className="flex justify-center space-x-2 mt-4">
          {videos.map((_, index) => (
            <button
              key={index}
              onClick={() => setActiveVideo(index)}
              className={`h-3 w-3 rounded-full transition-colors duration-300 ${
                activeVideo === index ? "bg-blue-500" : "bg-gray-300"
              }`}
            ></button>
          ))}
        </div>
      </div>

      {/* Right Panel (Blogs) */}
      <div className="w-1/2 bg-white shadow-lg rounded-lg p-4 flex flex-col justify-between h-full transition-all duration-500">
        <h2 className="text-xl font-bold mb-4">Health Blogs</h2>
        <div className="mb-4 flex-grow">
          <a href={blogs[activeBlog].href} target="_blank" rel="noopener noreferrer">
            <img
              src={blogs[activeBlog].src}
              alt="Blog Thumbnail"
              className="w-full h-auto object-cover rounded-lg transition-all duration-500"
            />
          </a>
        </div>
        <div className="flex justify-center space-x-2 mt-4">
          {blogs.map((_, index) => (
            <button
              key={index}
              onClick={() => setActiveBlog(index)}
              className={`h-3 w-3 rounded-full transition-colors duration-300 ${
                activeBlog === index ? "bg-blue-500" : "bg-gray-300"
              }`}
            ></button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Talks_Blogs;
